var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonAttendanceModal',{attrs:{"title":_vm.title}},[_c('EmployeeDailyAttendanceTable',{attrs:{"items":_vm.items,"is-busy":_vm.isBusy,"pagination":_vm.pagination,"manageable":false},on:{"changePage":_vm.handlePageChange,"expandDetails":_vm.handleExpand}}),_c('ClockRecordModal',{attrs:{"is-busy":false,"records":_vm.records}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }